module.exports = __webpack_public_path__ + "static/img/icon.e3aa6f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon.png
// module id = edSy
// module chunks = 0